export default "__VITE_ASSET__p5Ys02R2__"